import {SHAPE_PART_ID} from "./constants";

export const SHAPE_HARDCODED_PART_IDS = [
  SHAPE_PART_ID.seamPiece,
  SHAPE_PART_ID.backsplashPiece,
  SHAPE_PART_ID.waterfallPiece,
  SHAPE_PART_ID.slabPlaceHolder,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
];

export const SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE = [
  SHAPE_PART_ID.seamPiece,
  SHAPE_PART_ID.backsplashPiece,
  SHAPE_PART_ID.waterfallPiece,
  SHAPE_PART_ID.slabPlaceHolder,
];

export const SHAPE_PART_IDS_FROM_ADDITIONAL_SHAPES_LIST = [
  SHAPE_PART_ID.backsplashPiece,
  SHAPE_PART_ID.waterfallPiece,
];
